import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useAppContext } from '../../context/AppContext';
import { authFetch } from '../../api';

const Sidebar = ({ onClose }) => {
  const { isLoading, refreshData, syncError } = useAppContext();
  const navigate = useNavigate();

  const navItems = [
    { name: 'Dashboard', path: '/', icon: FiIcons.FiGrid },
    { name: 'Tasks', path: '/tasks', icon: FiIcons.FiCheckSquare },
    { name: 'Task Log', path: '/task-log', icon: FiIcons.FiClock },
    { name: 'Agencies', path: '/agencies', icon: FiIcons.FiBriefcase },
    { name: 'Settings', path: '/settings', icon: FiIcons.FiSettings },
  ];

  const handleLogout = async () => {
    await authFetch('sign-out', { method: 'POST' });
    localStorage.removeItem('user_id');
    localStorage.removeItem('needs_password_reset');
    navigate('/login');
  };

  const isHealthy = !syncError;

  return (
    <div className="w-64 bg-slate-950 text-slate-200 flex flex-col h-full border-r border-slate-800">
      <div className="p-6 border-b border-slate-800 flex justify-between items-center">
        <div className="w-40 h-auto overflow-hidden rounded-xl">
          <img
            src="https://media-manager-c.questera.ai/greta-media/184c9c9a291724797b8ad828c55b10701c0f1ac03d6d548cee29a666ff97a2e9df5b13aa801d7dcc8d672f63188942d5/images/aW1hZ2UvcG5n/c78450fbbdba9eba333bc0f72a71b422.png"
            alt="Shift Creative Logo"
            className="w-full h-full object-contain"
          />
        </div>
        <button
          onClick={onClose}
          className="lg:hidden p-2 text-slate-500 hover:text-white transition-colors"
        >
          <SafeIcon icon={FiIcons.FiX} className="text-xl" />
        </button>
      </div>

      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            onClick={() => onClose && onClose()}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                isActive
                  ? 'bg-teal-500/10 text-teal-400 border border-teal-500/20 shadow-sm'
                  : 'text-slate-400 hover:bg-slate-900 hover:text-slate-200'
              }`
            }
          >
            <SafeIcon icon={item.icon} className="text-lg" />
            <span className="font-bold text-sm">{item.name}</span>
          </NavLink>
        ))}
      </nav>

      <div className="p-4 space-y-4 border-t border-slate-800">
        <div className={`p-3 rounded-2xl border transition-all ${
          syncError ? 'bg-red-500/10 border-red-500/30' :
          isHealthy ? 'bg-teal-500/5 border-teal-500/20' :
          'bg-amber-500/5 border-amber-500/20'
        }`}>
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              <div className={`w-2 h-2 rounded-full ${
                syncError ? 'bg-red-600 animate-pulse' :
                isHealthy ? 'bg-teal-500' :
                'bg-amber-500 animate-pulse'
              }`} />
              <span className={`text-[10px] font-black uppercase tracking-widest ${
                syncError ? 'text-red-500' :
                isHealthy ? 'text-teal-400' :
                'text-amber-400'
              }`}>
                {syncError ? 'Sync Error' : isHealthy ? 'Synced' : 'Connecting...'}
              </span>
            </div>
            <button
              onClick={refreshData}
              disabled={isLoading}
              className="text-slate-500 hover:text-white transition-colors disabled:opacity-30"
            >
              <SafeIcon icon={FiIcons.FiRefreshCw} className={`text-xs ${isLoading ? 'animate-spin' : ''}`} />
            </button>
          </div>

          {!syncError && (
            <p className="text-[10px] text-slate-500 font-bold uppercase truncate">
              NCB Database Active
            </p>
          )}
        </div>

        <div className="bg-slate-900 border border-slate-800 p-2 rounded-xl flex items-center justify-between group">
          <div className="flex items-center gap-3 px-2 py-1 min-w-0">
            <div className="w-8 h-8 rounded-lg bg-teal-600 flex items-center justify-center font-black text-white shadow-lg shadow-teal-900/20 text-xs shrink-0">
              SC
            </div>
            <div className="min-w-0">
              <p className="text-sm font-bold text-slate-200 truncate">Admin</p>
              <p className="text-[10px] text-teal-500 uppercase font-black tracking-widest truncate">Portal</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="p-2 text-slate-500 hover:text-red-400 transition-colors opacity-0 group-hover:opacity-100"
            title="Sign Out"
          >
            <SafeIcon icon={FiIcons.FiLogOut} className="text-lg" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;